/** Портфельная ИИ: сотрудники (зам / менеджер с флагом) — кабинетный URL. */
export const SYSTEM_AI_EMPLOYER_BASE = '/employee/system-ai-analytics'
/** Админка: тот же React, отдельный путь в админской оболочке. */
export const SYSTEM_AI_ADMIN_BASE = '/admin/system-ai-analytics'

export function systemAiBasePath(pathname: string): string {
  const p = String(pathname || '')
  if (p.startsWith(SYSTEM_AI_EMPLOYER_BASE)) return SYSTEM_AI_EMPLOYER_BASE
  if (p.startsWith('/employer/system-ai-analytics')) return SYSTEM_AI_EMPLOYER_BASE
  if (p.startsWith(SYSTEM_AI_ADMIN_BASE)) return SYSTEM_AI_ADMIN_BASE
  return SYSTEM_AI_EMPLOYER_BASE
}
